import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToHash from "./components/ScrollToHash";
import Landing from "./pages/Landing";
import Services from "./pages/Services";
import TestimonialsPage from "./pages/Testimonials";
import ContactPage from "./pages/Contact";
import CompanyTraining from "./pages/CompanyTraining";
import HowIWork from "./pages/HowIWork";
import Login from "./pages/Login";
import StudioLogin from "./pages/StudioLogin";
import Register from "./pages/Register";
import PaymentReturn from "./pages/PaymentReturn";
import PublicBook from "./pages/PublicBook";
import ClientDashboard from "./pages/ClientDashboard";
import WorkoutDetail from "./pages/WorkoutDetail";
import AdminDashboard from "./pages/AdminDashboard";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <ScrollToHash />
            <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/company-training" element={<CompanyTraining />} />
            <Route path="/how-i-work" element={<HowIWork />} />
            <Route path="/login" element={<Login />} />
            <Route path="/studio-login" element={<StudioLogin />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payment/return" element={<PaymentReturn />} />
            <Route path="/book/:token" element={<PublicBook />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ClientDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/programs/:programId"
              element={
                <ProtectedRoute>
                  <WorkoutDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
